import { Injectable } from '@angular/core';
import { STORAGE_KEYS, LEGACY_STORAGE_KEYS } from '../../../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  getAccessToken(): string | null {
    try {
      // Fallback de leitura na chave antiga (__pwa_bridge_token) por 1 release — TODO remover
      let token = localStorage.getItem(STORAGE_KEYS.BRIDGE_TOKEN) ||
        localStorage.getItem(LEGACY_STORAGE_KEYS.BRIDGE_TOKEN);
      if (token) {
        return token;
      }

      token = sessionStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN);
      if (token) {
        return token;
      }

      return null;

    } catch (error) {
      return null;
    }
  }

  hasValidToken(): boolean {
    return this.getAccessToken() !== null;
  }

  refreshToken(): string | null {
    return this.getAccessToken();
  }
}